@if (data.showMarket) {
<div class="k-p-2">
  <app-market-selector [showLabel]="true" [(ngModel)]="selectedMarketId" name="market"></app-market-selector>
</div>
}
<div #content style="width: 100%; height: calc(100vh - 230px)">
<kendo-grid [data]="gridData" [pageSize]="state.take" [skip]="state.skip" [pageable]="true" [filterable]="true"
  [filter]="state.filter" (dataStateChange)="dataStateChange($event)" (save)="save()"
  [kendoGridSelectBy]="'materialIndex'" [(selectedKeys)]="selectedMaterialIndexes" (cancel)="cancel()">

  <kendo-grid-checkbox-column [width]="120" [showSelectAll]="true"></kendo-grid-checkbox-column>

  <kendo-grid-column field="materialDescription" title="{{ 'App.Material' | translate }}" [filterable]="true">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [showOperators]="false" [column]="column" [filter]="filter">
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="entityGroupDescription" title="{{ 'AppComponent.Admin_EntityGroup' | translate }}"
    [filterable]="true">

    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-kendo-grid-drop-down-filter [data]="entityGroups" textField="entityGroupDescription"
        valueField="entityGroupIndex" [filter]="filter" [filterCode]="'entityGroupIndex'">
      </app-kendo-grid-drop-down-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="materialUsageCount" title="{{ 'Tactical.ConnectedBudgetLines' | translate }}"
    [filterable]="true">

    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-kendo-grid-drop-down-filter [data]="isMaterialUsed" textField="text" valueField="key" [filter]="filter"
        [filterCode]="'isMaterialUsed'">
      </app-kendo-grid-drop-down-filter>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>
</div>
<kendo-dialog-actions layout="end">
  <button size="small" themeColor="primary" [svgIcon]="saveIcon" kendoButton (click)="save()"></button>
  <button size="small" themeColor="error" [svgIcon]="cancelIcon" kendoButton (click)="cancel()"></button>
</kendo-dialog-actions>
